import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { TourService } from 'ngx-ui-tour-md-menu';
import { BaseService } from './base.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TourStepsService {
  private tourService = inject(TourService);
  
  currentAnchor = signal('');
  isStartedTour = signal(false);

  constructor() { }

  public startTour = () => {
    this.tourService.start();
    this.isStartedTour.set(true);
  }

  public resetTour = () => {
    this.currentAnchor.set('');
    this.isStartedTour.set(false);
  }
}
